import { bodyClassManager } from '@rcm/dom';
import classNames from 'classnames';
import { Argument } from 'classnames';
import { useEffect } from 'react';
import useConstant from './useConstant';

const useBodyClasses = (...classes: Argument[]) => {
  const classList = useConstant(() => bodyClassManager.createClassList());

  const classesStr = classNames(...classes);

  useEffect(() => {
    classList.value = classesStr;
  }, [classesStr, classList]);

  useEffect(
    () => () => {
      classList.destroy();
    },
    [classList]
  );
};

export default useBodyClasses;
